'use client';
import React, { useEffect, useState } from 'react';
import Button from '@pezeshk-book/ui-kit/button';
import Div from '@pezeshk-book/ui-kit/div';
import Modal from '@pezeshk-book/ui-kit/modal';
import RadioButton from '@pezeshk-book/ui-kit/radio-button';
import Text from '@pezeshk-book/ui-kit/text';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '@store/root-reducer';
import { useRouter } from 'next-nprogress-bar';
import { SelectCityModalProps } from './select-city-modal.props';
import { LaboratoryActions } from '@store/lab/lab-actions';
import cityItemsApi from '@api/labs/city-items';
import { Skeleton } from '@pezeshk-book/ui-kit';
import getParseRoute from '@utils/helpers/parse-route';
import routes from '@routes';
import Chip from '@pezeshk-book/ui-kit/chip';
import FormControlLabel from '@pezeshk-book/ui-kit/form-control-label';
import { useParams } from 'next/navigation';
import getDictionary from '@dictionaries-client';
import { LocaleTypes } from '@dictionaries-types';

const SelectCityModal = ({ hashedId }: SelectCityModalProps) => {
  const router = useRouter();
  const dispatch = useDispatch();
  const { cityModal, selectedServiceId, selectedServiceSlug } = useSelector((state: RootState) => state.lab);
  const { lang } = useParams<{lang: LocaleTypes}>();
  const { services: { laboratory, chips } } = getDictionary(lang);
  const [cityList, setCityList] = useState<Array<{id: string, title: string}>>([]);
  const [loading, setLoading] = useState(true);
  const [selectedCity, setSelectedCity] = useState<any>();

  useEffect(() => {
    if (selectedServiceId) {
      getCityList();
    }
  }, [selectedServiceId]);

  const getCityList = async () => {
    try {
      const cities = await cityItemsApi({ hashedLabId: hashedId, hashedServiceSubTypeId: selectedServiceId });
      setCityList(cities?.data);
      setSelectedCity(cities?.data[0]);
      setLoading(false);
    } catch (error: any) {
      setLoading(false);
    }
  };

  const handleSelectCity = ({ city } : {city: any}) => {
    setSelectedCity(city);
  };
  const handleSubmit = () => {
    if (selectedCity) {
      handleClose();
      if (window.location.pathname.includes('/mobile')) {
        router.push(getParseRoute({ pathname: `/mobile${routes['route.labs.show']}`, query: { id: selectedServiceSlug, cityId: selectedCity.id, ci: selectedCity.city?.route_key }, locale: lang }));
      } else {
        router.push(getParseRoute({ pathname: routes['route.labs.show'], query: { id: selectedServiceSlug, cityId: selectedCity.id, ci: selectedCity.city?.route_key }, locale: lang }));
      }
    }
  };

  const handleClose = () => {
    setLoading(true);
    dispatch(LaboratoryActions.setCityModal({ open: false }));
  };

  return (
    <Modal open={cityModal} position={'bottom'} onClose={handleClose}>
      <Div className={'flex-col bg-white w-full p-3 rounded-t-lg overflow-auto relative'}>
        <Div className={'w-full sm:w-1/2 flex-col self-center'}>
          <Div className={'w-full items-center justify-between'}>
            <Text type={'bold'} color={'grey.800'}>
              {laboratory.index.city_modal_title}
            </Text>
            <Chip onClick={handleClose} onDelete={handleClose} variant={'outlined'} value={chips.close} color={'danger'}/>
          </Div>
          {loading ? (
            <Div className={'grid grid-cols-1 gap-5 my-8'}>
              <Skeleton className={'w-full'} size={'small'} color={'control'} />
              <Skeleton className={'w-full'} size={'small'} color={'control'} />
              <Skeleton className={'w-full'} size={'small'} color={'control'} />
              <Skeleton className={'w-full'} size={'small'} color={'control'} />
            </Div>
          ) : (
            <Div className={'grid grid-cols-1 gap-5 my-8'}>
              {cityList && cityList.length > 0 && cityList.map((item) => (
                <FormControlLabel label={item.title} key={item.id} className={'flex w-full items-center z-[5] gap-2'}>
                  <RadioButton onClick={() => handleSelectCity({ city: item })} color={'primary'} name={'city'} checked={selectedCity?.id === item.id} value={item.id}/>
                </FormControlLabel>
              ))}
            </Div>
          )}
          <Button loading={loading} disabled={loading} onClick={handleSubmit} className={'w-full self-center mt-5'}>
            {laboratory.index.buttons.confirm}
          </Button>
        </Div>
      </Div>
    </Modal>
  );
};

export default SelectCityModal;
